import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@atlassian/jira-global-settings-layout/src/index.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarGlobalSettingsSystem from '@atlassian/jira-navigation-apps-sidebar-global-settings-system/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@atlassian/jira-router-resources-navigation-sidebar-global/src/index.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { globalSettingsPerformanceWorkTypeProjectLimitRoute } from '@atlassian/jira-router-routes-admin-pages-performance-routes/src/globalSettingsPerformanceWorkTypeProjectLimitRoute.tsx';
import { workTypeProjectsLimitsResource } from '@atlassian/jira-router-resources-admin-pages-performance/src/services/work-type-project-limits/index.tsx';
import { workTypeProjectLimitMetricDetailEntryPoint } from './ui/spa/admin-pages/performance/metric-detail/work-type/project-limit/index.tsx';

export const globalSettingsPerformanceWorkTypeProjectLimitRouteEntry = createEntry(
	globalSettingsPerformanceWorkTypeProjectLimitRoute,
	() => ({
		group: 'global-settings',

		entryPoint() {
			return workTypeProjectLimitMetricDetailEntryPoint;
		},

		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SIDEBAR_ID.GLOBAL_SYSTEM_SETTINGS,
			menuId: MENU_ID.SETTINGS,
			sidebar: AsyncSidebarGlobalSettingsSystem,
		},

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			workTypeProjectsLimitsResource,
		],

		forPaint: [LazyAtlassianNavigation],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-admin-pages-performance-entries/src/globalSettingsPerformanceWorkTypeProjectLimitRouteEntry.tsx',
				whichExportToUse: 'globalSettingsPerformanceWorkTypeProjectLimitRouteEntry',
			},

			enabled: true,
		},
	}),
);
